import type { PropsWithChildren } from 'react'

import { useOneTrust } from '@circlefin/one-trust'
import { OneTrustProvider } from '@circlefin/one-trust/react/context/provider'

import { DatadogProvider } from '../DatadogProvider/DatadogProvider'

const Analytics: React.FC = () => {
  const { hasPerformance } = useOneTrust()

  if (hasPerformance) {
    return <DatadogProvider />
  }

  return null
}

export const AnalyticsProvider: React.FC<PropsWithChildren> = ({
  children,
}) => {
  return (
    <OneTrustProvider>
      <Analytics />
      {children}
    </OneTrustProvider>
  )
}
